import { Typography } from "@jti/ui/components/Typography";

import type { CategoryNameProps } from "./CategoryName.inputs.builder";

export function CategoryName({ name }: CategoryNameProps) {
  return (
    <Typography variant="h2" as="h1">
      {name}
    </Typography>
  );
}
